import { FormField } from '../forms/form-field.model';

export class FormSection {
  constructor(
    public name?: string,
    public atLeastOneRequired?: [[string]],
    public navigationName?: string,
    public rows?: FormField[][],
    public subsections?: [FormSection],
    public columns?: number
  ) { }
}


// WEBPACK FOOTER //
// ./src/app/forms/form-section.model.ts